<rt-dropdown [width]="DropdownWidth.FullWidth" #timeDropdownContainer class="viewport">
  @for (time of timesArr; track trackBy(i, time); let i = $index) {
    <rt-dropdown-item
      (click)="onTimeSelect(time)"
      [highlighted]="i === selectionIndex"
      #timeItemsQuery
      class="time-dropdown-item"
    >
      <span>{{ time }}</span>
    </rt-dropdown-item>
  }
</rt-dropdown>
